import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Message } from '@prisma/client';
import { MessageResourceTypeMappings } from '@aa/nest/resource';
import { messageCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class MessageService extends BaseResourceService<MessageResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'messages');
  }
}
